import PropTypes from 'prop-types';
import usagerClientReducer from '../../store/usagerReducer';
import { API_RECUPERER_FICHIER_TELECHARGEMENT } from '../../constants/apiUrls.constants';

const DisplayFileFromBack = async (uuidFile) => {
    const axios = usagerClientReducer.getInstance();

    const dataFile = await axios
        .get(API_RECUPERER_FICHIER_TELECHARGEMENT + uuidFile)
        .then((response) => {
            return response.data;
        });

    const url = `data:${dataFile.data.mimeTypeFichier};base64,${dataFile.data.contenuFichier}`;
    return {
        libelle: dataFile.data.libelleUtilisateur,
        contenu: url,
    };
};

DisplayFileFromBack.prototype = {
    uuidFile: PropTypes.string.isRequired,
};

export default DisplayFileFromBack;
